var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFadSaveas = function SvgFadSaveas(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M93.598 47.311c-8.112 0-13.707 6.252-13.707 13.16 0 1.167-.043 9.642-.043 9.642H56.122c-3.995 0-9.15 4.554-9.15 12.205v118.45c0 5.596 2.334 8.666 10.13 8.666h120.895c7.212 0 8.762-3.277 8.762-8.014v-25.038h8.596c6.556 0 13.419-7.717 13.419-13.448V86.32c0-2.21-.624-5.676-1.44-7.254 0 0 .538.572 0 0-.539-.572-28.031-28.927-29.337-30.28-1.457-1.507 0 0 0 0-1.827-.98-5.1-1.768-7.306-1.759 0 0-68.98.284-77.093.284z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.704 84.577c1.107 0 2.01.905 2.02 1.994l.632 83.793s0 6.424 5.655 6.424 85.653-.36 85.653-.36v15.182l-103.782.727a3.957 3.957 0 0 1-3.996-3.969V88.573a3.992 3.992 0 0 1 3.993-3.996h9.825z",
    stroke: "#979797",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.167 65.105a2.04 2.04 0 0 1 1.997-2.033l7.252-.095a1.966 1.966 0 0 1 1.997 1.964v25.422c0 3.582 4.016 7.397 7.74 7.397h48.898c3.4 0 8.151-4.695 8.151-7.397V64.31c0-1.106.379-1.554.379-1.554l20.247 21.281c.76.8 1.379 2.34 1.38 3.441l.114 69.98a3.987 3.987 0 0 1-3.993 4l-90.162-.105a4.006 4.006 0 0 1-4-4.008v-92.24z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.456 62.494c0-1.103.898-1.998 2.01-1.998h35.408c1.11 0 2.01.886 2.01 1.998v21.744a2.003 2.003 0 0 1-2.01 1.998h-35.409a1.998 1.998 0 0 1-2.009-1.998V62.494z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.073 105.18c13.095.206 25.771 11.676 25.771 25.676 0 14-11.831 25.72-25.11 25.511-13.278-.21-26.496-11.948-26.496-25.527 0-13.58 12.739-25.867 25.835-25.66z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.991 130.517c0 7.831 6.222 13.663 13.13 13.631 6.909-.031 12.767-5.768 12.801-13.507.035-7.738-6.24-13.231-12.94-13.231-6.7 0-12.99 5.276-12.99 13.107z",
    fill: "#FFF"
  }))));
};
export { SvgFadSaveas as ReactComponent };
export default __webpack_public_path__ + "static/media/fad-saveas.a55f14dc.svg";